import type { CreateUpsellWebApiResponseDto, UpsellTrackingIdType, UpsellType } from '@zg-rentals/ts-rins-client';
import { useUpsellWebApiHandler_createUpsell } from '@zg-rentals/ts-rins-client-react-query';
import { UpsellDismissedStorageKey } from '../types';

const getUpsellDismissedLocalStorageKey = (upsellType: UpsellType): string => {
  if (upsellType === 'LEASES_PAGE') {
    return UpsellDismissedStorageKey.LEASES;
  } else if (upsellType === 'YOUR_RENTAL_PAGE') {
    return UpsellDismissedStorageKey.YOUR_RENTAL;
  }

  return UpsellDismissedStorageKey.YOUR_RENTAL_APPLICATIONS;
};

export const hasUpsellBeenDismissed = (
  upsellType: UpsellType,
  trackingIdType: UpsellTrackingIdType,
  trackingId: string,
): boolean => {
  const localStorageKey = getUpsellDismissedLocalStorageKey(upsellType);
  const localStorageValue = localStorage.getItem(`${localStorageKey}${trackingId}`);

  if (localStorageValue !== null) {
    const parsedLocalStorageValue = JSON.parse(localStorageValue);
    return trackingIdType === 'LEASE_ID' ? !parsedLocalStorageValue : parsedLocalStorageValue;
  }

  return false;
};

interface UseCreateUpsellOptions {
  onSuccess?: (data: CreateUpsellWebApiResponseDto) => void;
  onError?: (error: unknown) => void;
}

/**
 * Hook to create an upsell using the new API client.
 * Component should check hasUpsellBeenDismissed before calling createUpsell.
 */
export const useCreateUpsell = ({ onSuccess, onError }: UseCreateUpsellOptions = {}) => {
  const { mutate, isPending } = useUpsellWebApiHandler_createUpsell({
    onSuccess,
    onError,
  });

  const createUpsell = (upsellType: UpsellType, trackingIdType: UpsellTrackingIdType, trackingId: string) => {
    mutate({
      postData: {
        type: upsellType,
        trackingIdType,
        trackingId,
      },
    });
  };

  return {
    createUpsell,
    isLoading: isPending,
  };
};
